import { RouterProvider, createBrowserRouter } from "react-router-dom";
import {
  Home,
  ParentalGuide,
  PositivePsychology,
  FreeChapter,
  CraftYourJourneyPage,
  ThankYouPage,
  ThankYouSelfDiscoveryPage,
  About,
  Contact,
  SelfDiscovery,
  SelfDiscoveryCheckout,
  Resources
} from "../pages";
import { PageNotFound } from "./404";
import OrderForm from "../components/OrderForm";
import { Authenticator } from "./Authenticator";

export const Navigator = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Authenticator />,
      children: [
        { path: "happyus-ppkp", element: <ParentalGuide /> },
        { path: "positive-psychology-sessions", element: <PositivePsychology /> },
        { path: "free-chapter", element: <FreeChapter /> },
        { path: "craft-your-journey", element: <CraftYourJourneyPage /> },
        { path: "thank-you-self-discovery", element: <ThankYouSelfDiscoveryPage /> },
        { path: "thank-you", element: <ThankYouPage /> },
        { path: "about", element: <About /> },
        { path: "self-discovery/checkout", element: <SelfDiscoveryCheckout /> },
        { path: "self-discovery", element: <SelfDiscovery /> },
        { path: "tools-and-bonuses", element: <Resources /> },
        { path: "contact", element: <Contact /> },
        { path: "order", element: <OrderForm /> },
        { path: "/", element: <Home /> },
      ],
    },
    // {
    //   path: "/auth",
    //   element: <Authenticator isAuth={true} />,
    //   children: [
    //     { path: "/auth", element: <SignIn /> },
    //     {
    //       path: "/auth/signup",
    //       element: <SignUp />,
    //     },
    //   ],
    // },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
};
